import { statusList } from "../../../../../helper/healthState";

export const flattenTreeData = (trees: any[], t) => {
  return trees.map((tree) => {
    const statusItem = statusList.find((item) => item.status === tree.health_state);
    return {
      id: tree.id,
      [t("name")]: tree.name,
      // [t("project")]: tree.area.project.name,
      [t("area")]: tree.area,
      // areaId: tree.areaId,
      [t("height")]: tree.height,
      // phase: tree.phase,
      [t("latitude")]: tree.position?.lat,
      [t("longitude")]: tree.position?.lng,
      [t("tree_species")]: tree.species?.name,
      // species_de_name: tree.species?.de_name,
      // genus: tree.species?.genus?.name,
      [t("planting_year")]: tree.planting_year,
      // blue_threshold: tree.blue_threshold,
      // green_threshold: tree.green_threshold,
      // yellow_threshold: tree.yellow_threshold,
      // water_requirement_per_day: tree.species?.water_requirement_per_day,
      // [t("number_of_installations")]: tree.installations?.length || 0,
      [t("health_state")]: t(statusItem.label),
    };
  });
};
